module.exports = __webpack_public_path__ + "static/media/map.9f26f2e1.svg";